import { useQueryClient } from "@tanstack/react-query"
import { useAuth } from "hooks/useAuth"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export const LogoutPage = () => {
  const queryClient = useQueryClient()
  const { logout } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    logout().then(() => {
      navigate("/")
      queryClient.clear()
    })
  }, [logout, navigate])

  return <div>Logging out...</div>
}
